import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as moment from "moment"
//import lib
// import { capitalize } from "../../lib/string";

import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';

export const orderPDF = (data: any) => {
    try {
        let resultArr: any[] = [];
        data.map((item: any) => {
            resultArr.push([
                moment(item.createdAt).format("MMM DD,YYYY,h:mm:ss A"),
                item.userCodeId,
                item.tableId,
                item.coin,
                item.beforeBalance,
                item.afterBalance,
                item.amount,
                item.category,
                item.type
            ]);
        });
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "landscape"; // portrait or landscape

        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(10);

        const title = "User Report";
        const headers = [
            [
                "Date",
                "User Id",
                "Reference Id",
                "Coin",
                "Before Balance",
                "After Balance",
                "Amount",
                "Category",
                "Type"
            ],
        ];

        let content = {
            startY: 50,
            head: headers,
            body: resultArr,
        };
        doc.text(title, marginLeft, 40);
        // doc.autoTable(content);
        // doc.save("User Details.pdf");

        autoTable(doc, { html: '#my-table' })

        autoTable(doc, content)

        doc.save('User.pdf')
    } catch (err) {
        console.log(err, "err");
    }
};

export const orderCSV = (data: any) => {
    try {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "User Report.csv");
        document.body.appendChild(link);
        link.click();
    } catch (err) {

    }
};

export const orderXLS = (data: any) => {
    try {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const fileData = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(fileData, "User Report.xlsx");
    } catch (err) {
        console.log(err, "err");
    }
};
